import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateSmsDripSequenceEdition as CreateSmsDripEditionMutation,
    CreateSmsDripSequenceEditionVariables as CreateSmsDripEditionMutationVariables,
    SmsDripEditionCreateInput,
} from 'nutshell-graphql-types';

import CREATE_SMS_DRIP_EDITION from '../mutations/create-sms-drip-sequence-edition.graphql';

export function useCreateSmsDripSequenceEdition(): {
    createDripEdition: (arg1: SmsDripEditionCreateInput) => Promise<any>;
    isCreating: boolean;
    error: string | null | undefined;
} {
    const [createDripEdition, {loading, error}] = useMutation<
        CreateSmsDripEditionMutation,
        CreateSmsDripEditionMutationVariables
    >(CREATE_SMS_DRIP_EDITION);

    return {
        createDripEdition: (input: SmsDripEditionCreateInput) =>
            createDripEdition({variables: {input}}),
        isCreating: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
